import React from "react";
import Drawer from "../../atoms/drawer/drawer.component.js";
import Form from "../../atoms/form/form.component.js";
import {ActionContainer, FormContainer, InputContainer} from "./form-drawer.styles.js";
function FormDrawer({
  title,
  drawerOpen,
  onClose,
  children,
  actions,
  innerRef,
  initialValues = {},
  onSubmit
}) {
  return /* @__PURE__ */ React.createElement(Drawer, {
    open: drawerOpen,
    onClose,
    title
  }, /* @__PURE__ */ React.createElement(FormContainer, null, /* @__PURE__ */ React.createElement(Form, {
    innerRef,
    initialValues,
    onSubmit
  }, /* @__PURE__ */ React.createElement(InputContainer, null, children), /* @__PURE__ */ React.createElement(ActionContainer, null, actions))));
}
export default /* @__PURE__ */ React.memo(FormDrawer);
